import { useFormik } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';
import { formikAddOrgAccess } from '../Constant';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';
import { Col, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import "./Users.css";
import MultiSelect from '../../../components/InputFields/MultiSelect';
import { decryptData } from '../../../utils/helper';
import { getOrg } from '../../../api/orgnizations';
import { failed, success } from '../../../utils/Tostify';
import { assignUserToOrg } from '../../../api/User';

const AddOrgAccessModal = ({setShowModalAddOrg, userData, refetch, refetchUser, assignedOrg}) => {
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const [orgData, setOrgData] = useState([]);
    const [filteredOrgData, setFilteredOrgData] = useState([]);
    const [Clinic, setClinic] = useState([]);
    const formik = useFormik({
        ...formikAddOrgAccess,
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                const payload = {...values, existingUserId: userData?._id};
                  res = await assignUserToOrg({values: payload, dispatch, token});
                if (res?.status == "SUCCESS") {
                    await refetch();
                    await refetchUser();
                    setIsLoading(false);
                    success(res?.message);
                    setShowModalAddOrg(false);
                }else{
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    const handleSubmit = async(e)=>{
        e.preventDefault();
        formik.handleSubmit(e);
        return true;
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        if (checked) {
          formik.setFieldValue('hospitalAccess', [...formik.values.hospitalAccess, value]);
        } else {
          formik.setFieldValue('hospitalAccess', formik.values.hospitalAccess?.filter((item) => item !== value));
        }
    };

    const getOrgList = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            res = await getOrg({ dispatch, token, page, limit , searchKey, dataLimit: "all" });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setIsLoading(false);
                setOrgData(responseData.items);
                setFilteredOrgData(responseData.items);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const handleOrgSearch = (e, newInputValue, reason) => {
        if (reason === "input") {
            // Safely get the search term, handling potential undefined values
            const searchTerm = (e?.target?.value || newInputValue || '').toLowerCase().trim();
            // Ensure orgData exists and filter safely
            const filteredOptions = (orgData || [])
                .filter(org =>
                    org?.name &&
                    org.name.toLowerCase().includes(searchTerm) &&
                    !assignedOrgIds.includes(org._id) &&
                    org?.active
                )
                .map(org => ({
                    label: org.name,
                    value: org._id
                }));
            setFilteredOrgData(filteredOptions);
        }
    };

    const handleSelect = (orgId)=>{
        setClinic(orgData?.find((obj)=> obj._id == orgId)?.clinics?.map((val)=> {
            return {label: val.name, value: val._id};
        }));
    };

    useEffect(() => {
        getOrgList(orgData?.currentPage, 10);
    }, []);
    const assignedOrgIds = assignedOrg?.items?.map(item => item?.organization?._id) || [];
    const options = filteredOrgData?.filter((obj) => !assignedOrgIds.includes(obj._id) && obj?.active)?.map((obj) => {
        return {
            label: obj?.name,
            value: obj?._id
        };
    });

    useEffect(() => {
        if (setShowModalAddOrg) {
          const modalBody = document.querySelector('.assign_modal_body');
          if (modalBody) {
            modalBody.scrollTop = 0;
          }
        }
      }, [setShowModalAddOrg]);


  return (
    <Fragment>
        <Modal isOpen={setShowModalAddOrg} toggle={setShowModalAddOrg} size="xl">
        <ModalHeader toggle={setShowModalAddOrg} className="assign_blk">Add Organization Access</ModalHeader>
        <ModalBody className="assign_modal_body">
        {isLoading ? <Loader /> : null}
            <div className="organization_form_block organization_blk  organization_modal">
                <Row className='m-0'>
                <Col lg={12} className="location_block p-0">
                    <MultiSelect
                        keyField={"orgId"}
                        multiple={false}
                        formik={formik}
                        label="Select Organization"
                        options={options?.length > 0 ? options : []}
                        // disabled={!options?.length > 0}
                        type="select"
                        placeholder="Select Organization"
                        value={formik?.values?.orgId}
                        // handleInput={(e, newInputValue, reason)=> handleOrgSearch(e, newInputValue, reason)}
                        onChange={handleSelect}
                        autoFocus={true}
                        handleInput={(e, actionMeta) =>
                            handleOrgSearch(e, e?.target?.value, actionMeta?.action)
                        }
                    />
                </Col>
                </Row>
                <Label className='mb-3'>Hospital Access</Label>
                <Row className='m-0 mb-3'>
                {Clinic?.length > 0 ? Clinic?.map((location, index) => (
                    <Col lg={12} className="location_block p-0" key={index} >
                        <div className='d-flex gap-2 align-items-center'>
                            <Input
                                type="checkbox"
                                label={location?.label}
                                name="hospitalAccess"
                                value={location?.value}
                                onChange={handleCheckboxChange}
                                className='m-0'
                                defaultChecked={formik.values.hospitalAccess.includes(location?.value)}
                            />
                            {location?.label}
                        </div>
                    </Col>
                )) : <Col lg={12}><span style={{color : "red"}}>No Clinic Assigned</span></Col> }
                </Row>
                <Row className='m-0'>
                <Col lg={12} className="location_block p-0">
                    <TextInput
                        keyField={"defaultLogInClinic"}
                        formik={formik}
                        label="Default Hospital"
                        options={Clinic?.filter((obj)=> formik.values.hospitalAccess.includes(obj.value))}
                        type="select"
                        placeholder="Default Hospital"
                        value={formik.values.defaultLogInClinic}
                        onChange={(e) => formik.setFieldValue("defaultLogInClinic", e.target.value)}
                    />
                </Col>
                </Row>
            </div>
        </ModalBody>
        <ModalFooter>
            <div className="d-flex justify-content-between">
                <button className="save_btn" onClick={setShowModalAddOrg}>Close</button>
                <button className="save_btn" type="submit" onClick={(e)=> handleSubmit(e)}>Save</button>
            </div>
        </ModalFooter>
        </Modal>
  </Fragment>
  );
};

export default AddOrgAccessModal;
